var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-iframe-wrapper"},[_c('iframe',{ref:"adIframe",staticClass:"full-width-carousel",attrs:{"src":_vm.iframeSrc},on:{"load":_vm.requestAdSize}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb3178f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ExternalAdFrame.vue
// module id = bY1H
// module chunks = 6